/**
 * 数值计算工具类
 * 用于解决浮点数计算精度问题,并提供常用的数值计算方法
 */

const calc = {}

/**
 * 加法 - 解决浮点数精度问题
 * @param {number} a 加数
 * @param {number} b 加数
 * @param {number} decimals 保留小数位数,默认2位
 * @returns {number}
 */
calc.add = function (a, b, decimals = 2) {
  const num1 = parseFloat(a) || 0
  const num2 = parseFloat(b) || 0
  const result = num1 + num2
  return Number(result.toFixed(decimals))
}

/**
 * 减法 - 解决浮点数精度问题
 * @param {number} a 被减数
 * @param {number} b 减数
 * @param {number} decimals 保留小数位数,默认2位
 * @returns {number}
 */
calc.sub = function (a, b, decimals = 2) {
  const num1 = parseFloat(a) || 0
  const num2 = parseFloat(b) || 0
  const result = num1 - num2
  return Number(result.toFixed(decimals))
}

/**
 * 乘法 - 解决浮点数精度问题
 * @param {number} a 因数
 * @param {number} b 因数
 * @param {number} decimals 保留小数位数,默认2位
 * @returns {number}
 */
calc.mul = function (a, b, decimals = 2) {
  const num1 = parseFloat(a) || 0
  const num2 = parseFloat(b) || 0
  const result = num1 * num2
  return Number(result.toFixed(decimals))
}

/**
 * 除法 - 解决浮点数精度问题
 * @param {number} a 被除数
 * @param {number} b 除数
 * @param {number} decimals 保留小数位数,默认2位
 * @returns {number}
 */
calc.div = function (a, b, decimals = 2) {
  const num1 = parseFloat(a) || 0
  const num2 = parseFloat(b) || 0
  if (num2 === 0) {
    console.warn('[calc.warn]: 除数不能为0')
    return 0
  }
  const result = num1 / num2
  return Number(result.toFixed(decimals))
}

/**
 * 格式化为货币字符串
 * @param {number} num 数值
 * @param {number} decimals 保留小数位数,默认2位
 * @param {string} symbol 货币符号,默认'¥'
 * @returns {string}
 */
calc.currency = function (num, decimals = 2, symbol = '¥') {
  const result = this.toFixed(num, decimals)
  return `${symbol}${result}`
}

/**
 * 保留指定小数位数
 * @param {number} num 数值
 * @param {number} decimals 保留小数位数,默认2位
 * @returns {number}
 */
calc.toFixed = function (num, decimals = 2) {
  const number = parseFloat(num) || 0
  return Number(number.toFixed(decimals))
}

/**
 * 四舍五入
 * @param {number} num 数值
 * @param {number} precision 精度,默认2位小数
 * @returns {number}
 */
calc.round = function (num, precision = 2) {
  const factor = Math.pow(10, precision)
  return Math.round(num * factor) / factor
}

/**
 * 向上取整
 * @param {number} num 数值
 * @param {number} precision 精度,默认0位小数
 * @returns {number}
 */
calc.ceil = function (num, precision = 0) {
  const factor = Math.pow(10, precision)
  return Math.ceil(num * factor) / factor
}

/**
 * 向下取整
 * @param {number} num 数值
 * @param {number} precision 精度,默认0位小数
 * @returns {number}
 */
calc.floor = function (num, precision = 0) {
  const factor = Math.pow(10, precision)
  return Math.floor(num * factor) / factor
}

// 
calc.convertToUpperCase = (amount) => {
  // 处理非数字输入
  if (isNaN(amount)) { return '' }

  // 数字映射
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  // 单位分级（元/万/亿 + 个/十/百/千）
  const units = [['元', '万', '亿'], ['', '拾', '佰', '仟']];
  // 小数单位
  const fractions = ['角', '分'];

  // 处理符号
  let prefix = amount < 0 ? '负' : '';
  amount = Math.abs(Number(amount));

  // 处理小数部分（精确到分）
  let decimalStr = '';
  const cents = Math.round(amount * 100) % 100;
  if (cents > 0) {
    const jiao = Math.floor(cents / 10);
    const fen = cents % 10;
    decimalStr = (jiao > 0 ? digit[jiao] + fractions[0] : '') +
      (fen > 0 ? digit[fen] + fractions[1] : '');
  }

  // 处理整数部分
  let integer = Math.floor(amount);
  let integerStr = integer === 0 ? '零' : '';

  for (let i = 0; i < units[0].length && integer > 0; i++) {
    let groupStr = '';
    for (let j = 0; j < units[1].length && integer > 0; j++) {
      const num = integer % 10;
      groupStr = (num > 0 ? digit[num] + units[1][j] : '零') + groupStr;
      integer = Math.floor(integer / 10);
    }
    // 处理组内连续零和末尾零
    groupStr = groupStr.replace(/零+/g, '零').replace(/零$/, '');
    if (groupStr) {
      integerStr = groupStr + units[0][i] + integerStr;
    }
  }

  // 合并结果并清理冗余零
  let result = prefix +
    integerStr.replace(/零+/g, '零')
      .replace(/零元/, '元')
      .replace(/零$/, '') +
    (decimalStr || '整');

  // 特殊处理零金额
  if (result === '整') result = '零元整';

  return result;
}
export default calc
